module.exports = new __parcel__URL__("Project Plan.dc0a681a.svg").toString();